import { capitalize } from "@mui/material";
import { BudgetDetails, Integration } from "@/services/cloudchipr.api";
import { BudgetsScopeCell } from "@/components/pages/budgets-and-alerts/components/grids/budgets/components/cells/BudgetsScopeCell";
import { budgetAmountCellValueGetter } from "@/components/pages/budgets-and-alerts/components/grids/budgets/utils/helpers/value-getters/budgetAmountCellValueGetter";
import { money } from "@/utils/numeral/money";
import { UserActivityCell } from "@/components/pages/common/ag-grid/components/common-cell-renderers/UserActivityCell";
import { NotificationsCell } from "@/components/pages/common/ag-grid/components/common-cell-renderers/notifications-cell/NotificationsCell";
import { getBudgetDetailsHistoryFormatedDate } from "@/components/pages/budgets-and-alerts/components/drawer/budget-details-drawer/utils/helpers/getBudgetDetailsHistoryFormatedDate";
import { BudgetDetailsPeriod } from "@/components/pages/budgets-and-alerts/components/drawer/budget-details-drawer/components/body/common/BudgetDetailsPeriod";

export const getBudgetDetailsRows = (
  budget?: BudgetDetails,
  budgetIntegration?: Integration[],
  quarterStartMonth?: number,
) => {
  return [
    {
      title: "Budget Name",
      value: budget?.name,
    },
    {
      title: "Budget Scope",
      value: <BudgetsScopeCell openInNew budget={budget} />,
    },
    {
      title: "Period",
      value: <BudgetDetailsPeriod />,
    },
    {
      title: "Start Date",
      value: getBudgetDetailsHistoryFormatedDate(
        budget?.start_date ?? "",
        budget?.period,
        quarterStartMonth,
      ),
    },
    {
      title: "Budgeting Method",
      value: capitalize(budget?.type ?? ""),
    },
    {
      title: "Budget",
      value: money(budgetAmountCellValueGetter(budget)),
    },
    {
      title: "Threshold",
      value: budget?.thresholds.map(({ percent }) => `${percent}%`).join(", "),
    },
    {
      title: "Created By",
      value: (
        <UserActivityCell
          date={budget?.created_at ?? ""}
          name={budget?.created_by?.name ?? budget?.created_by?.email ?? ""}
          deleted={budget?.created_by?.status === "deleted"}
          profile={budget?.created_by?.profile}
        />
      ),
    },
    {
      title: "Last Modified By",
      value: (
        <UserActivityCell
          date={budget?.modified_at ?? ""}
          name={budget?.modified_by?.name ?? budget?.modified_by?.email ?? ""}
          deleted={budget?.modified_by?.status === "deleted"}
          profile={budget?.modified_by?.profile}
        />
      ),
    },
    {
      title: "Notification Method",
      value: (
        <NotificationsCell
          emails={budget?.email_to}
          integrations={budgetIntegration ?? []}
        />
      ),
    },
  ];
};
